import { render, staticRenderFns } from "./ProfileView.vue?vue&type=template&id=ae2d5e20&scoped=true&"
import script from "./ProfileView.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ProfileView.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ProfileView.vue?vue&type=style&index=0&id=ae2d5e20&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae2d5e20",
  null
  
)

export default component.exports